import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const analysisPayloadSchema = z.object({
  amount: z.number().min(0),
  apr: z.number().min(0),
  fees: z.number().min(0),
  term: z.number().int().min(1),
  monthly: z.number().min(0),
  total: z.number().min(0),
  interest: z.number(),
  verdict: z.string(),
  flags: z.array(z.object({ tone: z.enum(["danger", "warning", "success"]), text: z.string() })),
});

const saveInput = z.object({
  title: z.string().min(1).max(200),
  payload: analysisPayloadSchema,
});

export const saveAnalysis = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data) => saveInput.parse(data))
  .handler(async ({ data, context }) => {
    const { supabase, userId } = context;
    const { error } = await supabase.from("saved_analyses").insert({
      user_id: userId,
      title: data.title,
      payload: data.payload as any,
    });
    if (error) throw new Error(error.message);
    return { ok: true };
  });

export const listAnalyses = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data) => z.object({}).parse(data))
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const { data, error } = await supabase
      .from("saved_analyses")
      .select("id, title, payload, created_at")
      .eq("user_id", userId)
      .order("created_at", { ascending: false });
    if (error) throw new Error(error.message);
    return data ?? [];
  });

export const deleteAnalysis = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data) => z.object({ id: z.string().uuid() }).parse(data))
  .handler(async ({ data, context }) => {
    const { supabase, userId } = context;
    const { error } = await supabase
      .from("saved_analyses")
      .delete()
      .eq("id", data.id)
      .eq("user_id", userId);
    if (error) throw new Error(error.message);
    return { ok: true };
  });
